module.exports = __webpack_public_path__ + "img/inspiration.5f72930b.png";